export const colorsDefault = {
  getColorsDefault
}

function getColorsDefault (quantity = 11) {
  const colors = [
    '#4A90E2', // Azul
    '#2ECC71', // Verde
    '#E74C8C', // Rosa
    '#F1C40F', // Amarelo
    '#E67E22', // Laranja
    '#3498DB', // Azul claro
    '#8E44AD', // Roxo escuro
    '#1ABC9C', // Turquesa
    '#D35400', // Laranja escuro
    '#16A085', // Verde água
    '#9B59B6' // Roxo
  ]

  return colors.slice(0, quantity)
}
